import cx from 'classnames'
import { ChevronRight } from 'almanac-ui/icons'
import { MouseEventHandler } from 'react'
import Styles from './ExpandButton.module.scss'

import { ExpandButtonProps } from './Types'

const ExpandButton = ({ onPress, isExpanded = false }: ExpandButtonProps) => {
  const handleClick: MouseEventHandler = (e) => {
    e.stopPropagation()
    e.preventDefault()
    onPress(e)
  }

  return (
    <button
      onClick={handleClick}
      className={cx(Styles.expandButton, {
        [Styles.expanded]: isExpanded,
      })}
    >
      <ChevronRight />
    </button>
  )
}

export { ExpandButton }
